import React from 'react';
import Head from 'next/head';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TeacherLandingPage = ({ }) => {
    return (
        <div className="flex flex-col items-center justify-center bg-gray-100">
            <Head>
                <title>IELTS Teachers Dashboard</title>
                <meta name="description" content="IELTS teaching made easier." />
            </Head>

            <Header />

            <main className="my-12 max-w-4xl">
                <div className="text-center p-4 bg-blue-600 text-white">
                    <h1 className="text-4xl font-bold mb-3">IELTS Teacher Dashboard</h1>
                    <p className="text-lg">Transform the Way You Teach IELTS</p>
                </div>

                <section className="flex flex-wrap justify-around m-4">
                    <div className="p-4 bg-white shadow-lg rounded-md m-2 w-96">
                        <h2 className="text-xl font-bold mb-2 text-blue-600">Progress Tracking</h2>
                        <p>Monitor your students' progress. Identify strengths and areas that need improvement. Tailor your teaching approach with data-driven insights.</p>
                    </div>
                    <div className="p-4 bg-white shadow-lg rounded-md m-2 w-96">
                        <h2 className="text-xl font-bold mb-2 text-blue-600">Mock Exam Platform</h2>
                        <p>Create simulated exams to prepare your students for the real IELTS test. Mimics the IELTS format, conditions, and scoring system.</p>
                    </div>
                    <div className="p-4 bg-white shadow-lg rounded-md m-2 w-96">
                        <h2 className="text-xl font-bold mb-2 text-blue-600">Time Saver</h2>
                        <p>Automate the tedious task of grading essays. Our AI does it consistently, accurately, and in a fraction of the time it would take manually.</p>
                    </div>
                    <div className="p-4 bg-white shadow-lg rounded-md m-2 w-96">
                        <h2 className="text-xl font-bold mb-2 text-blue-600">Anywhere, Anytime</h2>
                        <p>Access student essays, assign tasks, and provide feedback from anywhere at any time. Designed for flexibility and convenience.</p>
                    </div>
                </section>

                <div className="p-4 bg-blue-600 text-white text-center">
                    <h2 className="text-3xl font-bold mb-3">Get Early Access</h2>
                    <p className="text-lg mb-3">We're inviting a select group of IELTS teachers to try our platform before it's made available to the public.</p>
                    <p>To apply, send an email to <a href="mailto:yura@yura.ai" className="underline">yura@yura.ai</a></p>
                </div>
            </main>

            <Footer />
        </div>
    );
}

export default TeacherLandingPage;
